import { Injectable } from '@angular/core';
import { MeService } from '../me/me.service';
import { environment } from '../../../../environments/environment';
import { permissionBase, PermissionEnum, permissionProd, ResourceEnum } from '../../../../environments/shared-environment/permission';
import type { RolesEnum } from '../user/models/roles.enum';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(
    private readonly meService: MeService,
  ) { }

  public has(resource: ResourceEnum, permission: PermissionEnum): boolean {
    if (!permission)
      return false;

    const user = this.meService.getMe();

    if (!user || !user.roles)
      return false;

    return this.hasPermission(resource, permission, user.roles);
  }

  public hasPermission(resource: ResourceEnum, action: PermissionEnum, role: RolesEnum): boolean {
    const rolePermissions = permissionBase[role];
    if (!rolePermissions) return false;

    const resourcePermissions = rolePermissions[resource];
    if (!resourcePermissions) return false;

    return resourcePermissions[action] ?? false;
  }

}
